import { useMemo } from "react";

import { ICatalogue } from "../../../../apis/useGetCatalogueData/types";

export const useSetItemBasePrice = (
	items: ICatalogue[],
	item_id: string,
	peg_base_price: boolean,
	base_price: number,
	customize: boolean
) => {
	return useMemo(() => {
		if (!peg_base_price && customize) return base_price;

		return items.find(({ id }) => id === item_id)?.price ?? 0;
	}, [items, item_id, peg_base_price, base_price]);
};
